import { makeAutoObservable, observable, runInAction } from "mobx"
import { CheckAssetSectionFilesExist } from "../models/asset-section-models"
import { checkAssetSectionFilesExist } from "../services/asset-section-services"

class AssetSectionFilesStore {
    assetSectionFilesMap: Record<string, CheckAssetSectionFilesExist> = observable.object({})
    loadingStates: Record<string, boolean> = observable.object({})

    constructor() {
        makeAutoObservable(this)
    }
    get assetSectionFiles() {
        return Object.values(this.assetSectionFilesMap)
    }

    get isAnySectionLoading() {
        // Check if any value in loadingStates is true
        return Object.values(this.loadingStates).some(state => state === true)
    }

    isLoading(assetSectionId: string) {
        return !!this.loadingStates[assetSectionId]
    }

    loadassetSectionFiles = async (assetSectionId: string) => {
        if (this.isLoading(assetSectionId) || this.assetSectionFilesMap[assetSectionId]) {
            return
        }

        runInAction(() => {
            this.loadingStates[assetSectionId] = true
        })

        try {
            const result = (await checkAssetSectionFilesExist(assetSectionId)) as CheckAssetSectionFilesExist
            runInAction(() => {
                this.assetSectionFilesMap[assetSectionId] = result
            })
        } catch (e) {
            console.error("error in loadassetSectionFiles", e)
        } finally {
            runInAction(() => {
                this.loadingStates[assetSectionId] = false
            })
        }
    }
}

export default new AssetSectionFilesStore()
